import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MailCheck, MailX } from 'lucide-react';

type Phase = 'confirm' | 'loading' | 'success' | 'invalid';

export function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [phase, setPhase] = useState<Phase>(token ? 'confirm' : 'invalid');

  const handleConfirm = async () => {
    if (!token) {
      setPhase('invalid');
      return;
    }
    setPhase('loading');
    try {
      // Public endpoint — plain fetch (no auth interceptors). POST so email
      // scanners that pre-fetch the link can't trigger the opt-out.
      const res = await fetch('/api/public/unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      const data = (await res.json().catch(() => ({}))) as { status?: string };
      setPhase(res.ok && data.status === 'success' ? 'success' : 'invalid');
    } catch {
      setPhase('invalid');
    }
  };

  const ok = phase === 'success';

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas px-4">
      <div className="max-w-md w-full text-center bg-surface border border-border rounded-2xl p-8 space-y-4">
        {ok ? (
          <MailCheck className="w-12 h-12 mx-auto text-success" />
        ) : (
          <MailX className="w-12 h-12 mx-auto text-ink-tertiary" />
        )}

        {phase === 'confirm' && (
          <>
            <h1 className="text-xl font-bold text-ink-primary">Cancelar inscrição</h1>
            <p className="text-ink-secondary text-sm">
              Confirme abaixo para não receber mais e-mails de marketing.
            </p>
            <button
              type="button"
              onClick={handleConfirm}
              className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium bg-ink-primary text-canvas rounded-lg hover:bg-ink-secondary"
            >
              Confirmar descadastro
            </button>
          </>
        )}

        {phase === 'loading' && (
          <>
            <h1 className="text-xl font-bold text-ink-primary">Processando…</h1>
            <p className="text-ink-secondary text-sm">Aguarde um instante.</p>
          </>
        )}

        {phase === 'success' && (
          <>
            <h1 className="text-xl font-bold text-ink-primary">Inscrição cancelada</h1>
            <p className="text-ink-secondary text-sm">
              Você não receberá mais e-mails de marketing. Se mudar de ideia, entre em contato
              conosco.
            </p>
          </>
        )}

        {phase === 'invalid' && (
          <>
            <h1 className="text-xl font-bold text-ink-primary">Não foi possível processar</h1>
            <p className="text-ink-secondary text-sm">
              O link de descadastro é inválido ou expirou. Tente novamente pelo link mais recente do
              e-mail.
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default UnsubscribePage;
